var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19509_72160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26062 18.2081V21.0831H17.6773V18.2081M17.6773 9.58315V6.70815L13.8439 1.91648H4.26062V9.58315",
    stroke: "#CE1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8856 1.91648V6.70815H17.6773",
    stroke: "#CE1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13562 5.75009H9.05229",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.594 9.58301H2.34395C1.81468 9.58301 1.38562 10.0121 1.38562 10.5413V17.2497C1.38562 17.7789 1.81468 18.208 2.34395 18.208H19.594C20.1232 18.208 20.5523 17.7789 20.5523 17.2497V10.5413C20.5523 10.0121 20.1232 9.58301 19.594 9.58301Z",
    stroke: "#CE1111",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73975 11.9788H7.61475L4.73975 15.8122H7.61475",
    stroke: "#CE1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.969 11.9788V15.8122M14.3232 11.9788V15.8122",
    stroke: "#CE1111",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3231 11.9788H16.0002C16.3179 11.9788 16.6226 12.1051 16.8473 12.3297C17.0719 12.5544 17.1981 12.8591 17.1981 13.1768C17.1981 13.4945 17.0719 13.7992 16.8473 14.0238C16.6226 14.2485 16.3179 14.3747 16.0002 14.3747H14.3231",
    stroke: "#CE1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19509_72160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0.618896)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.b2e1b1ffef739051977031007f5ebdef.svg";
export { ForwardRef as ReactComponent };